import { api, utils } from '@seaoil/component-lib';

const { mySEAOIL } = api;
const { logger } = utils;

/**
 * Update the task using data
 * @param {Object} params.data - data to be sent
 * @param {*} params.setState
 */
function updateTask(params = {}) {
  const { data } = params;
  // setState((curr) => ({
  //   ...curr,
  //   message: 'Submitting your action... Please wait.',
  //   sent: true,
  // }));

  logger.verbose('Sending task response');
  logger.debug({ PARAMS: params });

  return mySEAOIL.workflow.updateTask(data).send()
    .then((result) => {
      logger.debug(result);
      // setState((curr) => ({
      //   ...curr,
      //   message: 'Task has been updated',
      // }));
    })
    .catch((error) => {
      logger.info({ ...error });
      const { response } = error;
      let exception = 'Unknown error. Please try again later.';

      if (response && response.data && response.data.message) {
        exception = `${response.data.message}.`
          + ` [ERROR: ${response.status}]`;
      }

      // setState((curr) => ({
      //   ...curr,
      //   message,
      //   error,
      // }));

      return { exception };
    });
}

export default updateTask;
